module.exports = __webpack_public_path__ + "img/thumbnail_Gemsbok_f_albino.315a1d16.png";